import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { environment } from '../environment/production';

function RegistrationClose() {
    const [formdata,setFormData]=useState({
        email_id:''
    })
    const [errormsg,setErrorMsg]=useState({
        email_id:''
    })
    const navigate = useNavigate();
    function handleValidations(e){
        if(e.target.email_id.value==""){
            setErrorMsg({email_id:"Email id can not be blank"})
        }else{
            axios.post(environment.apiUrl+"/UserMng/forgotPassword",JSON.stringify(formdata))
            .then((resp)=>{
              
               if(resp['data']['status']==1){
                alert(resp['data']['msg'])
               }else{
                alert(resp['data']['msg'])
               }
               
            })
            
        }
       
    }
    const handleForgotPassword=(e)=>{
        e.preventDefault();
        formdata.email_id=e.target.email_id.value;
        setFormData(...[formdata])
        handleValidations(e)
    }
  return (
    <>
    <div className="container-fluid" style={{margin:'0%',padding:'0%',boxSizing:'border-box'}}>
    <h5 className="text-center" style={{fontSize:'2rem', fontWeight:'bold'}}>GSTAT Deputation Application Portal</h5>
    <div className="login-page login-page9">   {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
   
     <div className="login-page9-wrapper" style={{width:"70%"}}>
     
     <marquee behavior="" direction="left"><h3>Submission of applications for the posts of staff and Officers of GSTAT has temporarily been kept on hold. The facilty may be re-opened based on processing of the applications received and ascertainment of posts remaining vacant, if any.</h3></marquee>
    </div>
    </div>
    </div>
    
    </>
  )
}

export default RegistrationClose